import dynamic from "next/dynamic";

const Header = dynamic(() => import("components/AppLayout/Header"), {
  ssr: false,
});
const Footer = dynamic(() => import("components/AppLayout/Footer"), {
  ssr: false,
});

export default function AppLayout({ children, data }) {
  if (data.footer && data.footer.submenus) {
    data.header.submenus = data.footer.submenus;
  }
  return (
    <>
      <Header data={data.header} />
      {children}
      <Footer data={data.footer} />
    </>
  );
}
